export default function(data) {
  var self = this;

  self.$el = $('#js-export-course');

  self.exportCourseFiles = ko.mapping.fromJS(Kadenze.Util.sortArray(JSON.parse(data).course_exports, 'created_at', 'descending'));
  self.courseName = ko.observable(self.exportCourseFiles()[0].name());

  self.downloadCourseExport = function(data,event) {
    var url = Kadenze.Routes.course_export_download_path(data.id());
    window.location.href = url;
  };
}
